import script from "./PdfViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&setup=true&lang=ts"

import "./PdfViewer.vue?vue&type=style&index=0&id=357446d2&scoped=true&lang=css"
import "./PdfViewer.vue?vue&type=style&index=1&id=357446d2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357446d2"]])

export default __exports__